module.exports = __webpack_public_path__ + "img/sms-email-big.9dbad81e.svg";